import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../content/CustomImage.vue.js';
import __vue_component__$1 from '../SdsIcon/SdsIcon.vue.js';

var script = defineComponent({
    name: 'SdsFlag',
    props: {
        flagName: {
            type: String,
            required: true,
        },
        flagPath: {
            type: String,
            required: false,
            default: 'https://scorealarm-stats.freetls.fastly.net/app-assets/flags/',
        },
        size: {
            type: String,
            required: false,
            default: 'sm'
        },
        iconName: {
            type: String,
            required: false,
            default: '',
        },
    },
    components: {
        CustomImage: __vue_component__,
        SdsIcon: __vue_component__$1,
    },
});

export default script;
